<template>
  <div :id="`Slider_${id}`" :class="[`main-${id}`, `home-class-main`]" @mouseleave="actRemovePlayer" style="min-height: 5rem; margin: 2rem 0;">
    <div class="onhover-poster" :id="`onhover-${id}`"  :class="{ visible: selected, hidden: !selected }"

      @mouseleave="actRemovePlayer" >
      <div class="hover-card"  v-if="screen.itemType !== 'PROMOTIONS'">
        <figure>
          <div style="height: 12rem;">
            <div v-if="onHoverSelectedItem && onHoverSelectedItem.isActiveVideo" style="position:relative;">
              <video :src="landscapeVideo" :id="`sliderVideoTrack-${id}`" loading="lazy" alt=""
                :poster="landscapseImage" class="image__item_video" muted autoplay loop @click="redirectToDetailPage(onHoverSelectedItem)" />
              <div class="mute-unmute-btn-slider" @click="ChangeMute" v-if="landscapeVideo">
                <VolumeIcon :status="ismuted ? 'mute' : 'unmute'" :dimensions="volumeIconDimensions" />
              </div>
              <div class="Episode-playbutton" v-if="(onHoverSelectedItem.objecttype.toLowerCase() === 'content' && onHoverSelectedItem.category.toLowerCase() == 'tvshow') || fromContinueSlider">
                <PlayButton :whereIamFrom="'episode'" :content="onHoverSelectedItem || null" :playerInstance="playerInstance"></PlayButton>
              </div>
              <div class="badge" style="position:absolute;padding:0.2rem;background:red;top: 5px; left: 5px;font-size: 0.8rem;border-radius:0.25rem;" v-if="onHoverSelectedItem.objecttag && onHoverSelectedItem.objecttag.length && onHoverSelectedItem.objecttag[0]">{{onHoverSelectedItem.objecttag[0]}}</div>
            </div>
            <img src="@/assets/placeholder-lands.svg" loading="lazy" class="image__item" v-else />
            <div class="remove-btn" v-if="showRemove" @click="removeDataFromFire(onHoverSelectedItem)">
              <img data-nimg="fill" decoding="async" class="remove-watchlist" src="@/assets/icons/close_with_shadow.svg" alt />
            </div>
          </div>
          <figcaption class="related-meta-data">
            <div class="related-action-btns">
              <div class="watch-now-btn" v-if="!(onHoverSelectedItem.category == 'TVCHANEL' && isItFutureProgram(onHoverSelectedItem))">
                <PlayButton :whereIamFrom="'hoverCard'" :content="onHoverSelectedItem || null" :playerInstance="playerInstance" :screen="screen"></PlayButton>
              </div>
              <div class="add-to-watch-list" v-if="selected && onHoverSelectedItem.contentprovider !== 'hotgo' && !fromWatchListSlider">
                <WatchlistBtn :content="onHoverSelectedItem || null" />
              </div>
              <div class="add-to-watch-list">
                <LikeBtn :content="onHoverSelectedItem || null" v-if="selected" />
              </div>
            </div>
            <div class="related-meta-data-details" v-if="onHoverSelectedItem">
              <h1 class="fig-title">{{ onHoverSelectedItem.title }}</h1>
              <div class="fig-details">
                <div class="epg-info" v-if="onHoverSelectedItem.objecttype == 'EPGPROGRAMME'">{{ formatProgramTimeRange(onHoverSelectedItem) }}</div>
                <div class="main-info">
                  <div class="ua-rating" v-if="onHoverSelectedItem.advisory">
                    <p>{{ onHoverSelectedItem.advisory }}</p>
                  </div>
                  <div class="publish-year" v-if="onHoverSelectedItem.productionyear">
                    <p>{{ onHoverSelectedItem.productionyear }}</p>
                  </div>
                  <!-- <div class="duration" v-if="onHoverSelectedItem.duration">
                    <p>{{ this.calcTimeFormat(onHoverSelectedItem.duration) }}</p>
                  </div> -->
                  <div class="duration" v-if="onHoverSelectedItem.duration && onHoverSelectedItem.objecttype !== 'SERIES'">
                    {{ calcTimeFormat(onHoverSelectedItem.duration) }}
                  </div>
                  <div class="duration" v-if="onHoverSelectedItem.seasoncount && onHoverSelectedItem.objecttype === 'SERIES'">
                    {{ formatSeasonCount(onHoverSelectedItem.seasoncount) }}
                  </div>
                  <!-- <div v-if="onHoverSelectedItem.seasoncount" class="duration">{{ seasonCountShow(onHoverSelectedItem) }}</div> -->
                  <div class="pgrating" v-if="onHoverSelectedItem.channelno">
                    <p>CH NO : {{ onHoverSelectedItem.channelno }}</p>
                  </div>
                  <div class="pgrating" v-if="onHoverSelectedItem.catchupperiod">
                    <p>CU TV</p>
                  </div>
                  <div class="pgrating" v-if="onHoverSelectedItem.pgrating">
                    <p>{{ onHoverSelectedItem.pgrating }}</p>
                  </div>
                </div>
                <div class="main-genre">
                  <div class="sub-genre1" v-if="onHoverSelectedItem.category">
                    <p>{{ $t(onHoverSelectedItem.category) }}</p>
                  </div>
                  <div class="sub-genre2" v-if="onHoverSelectedItem.genre">
                    <p>{{ $t(onHoverSelectedItem.genre) }}</p>
                  </div>
                  <div class="sub-genre3" v-if="onHoverSelectedItem.contentlanguage && onHoverSelectedItem.contentlanguage.length > 0">
                    <p>{{ $t(onHoverSelectedItem.contentlanguage[0]) }}</p>
                  </div>
                </div>
              </div>
              <div class="fig-description" v-if="onHoverSelectedItem && onHoverSelectedItem.shortdescription">
                <!-- <span>{{onHoverSelectedItem.shortdescription}}</span> -->
                <span>{{ spliceText(onHoverSelectedItem.shortdescription, 90) }}</span>
              </div>
            </div>
          </figcaption>
        </figure>
      </div>
    </div>
    <div class="slider-category-title" v-if="screen && screen.title">{{ localDisplayLang === "es" ? (screen.title.es || screen.title.spa) : screen.title.default }}</div>
    <div class="slider-header">
      <div
        class="seeall"
      @click="redirectToSeeAll(screen)"
        v-if=" (contentData && contentData.length > 13) && showMore">
        <div class="more"> {{ $t("More") }} </div>
        <div> <img src="@/assets/icons/rightarrow.svg" alt="more" class="seeall-arrow" /> </div>
      </div>
    </div>
    <div :class="['swiper', `sliderRow${id}`]" style="position: relative;">
      <div class="swiper-wrapper">
        <div  v-for="(item, index) of contentData" :class="['swiper-slide', screenClass(screen.displayType, item)]"
          :id="`swiper-slide-${index}`" :key="index"
          @mouseover="handingTiming(true, item, $event)" @mouseleave.stop="actRemovePlayerX" @mouseout.stop="actRemovePlayerX">
          <img 
            @load="$event.target.classList.add('loaded')"
            class="poster-img"
            :id="`img-swiper-slide-${index}`"
            :alt="item.title || item.title.eng || item.title.en || item.title.spa"
            :src="getPoster(item, screen.displayType)"
            style="width: 100%;height:100%;object-fit: cover;" @click="redirectToDetailPage(item)"
            @error="actLoadError" 
            loading="lazy"
            />
            <span class="live-button" v-if="item.objecttype === 'CHANEL'"> {{$t('LIVE')}} </span>
            <span class="title-show" v-if="item.objecttype === 'EPGPROGRAMME'">{{ item.title || item.title.eng || item.title.en || item.title.spa }}</span>
            <div class="badge" v-if="item.objecttag && item.objecttag.length && item.objecttag[0]">{{item.objecttag && item.objecttag.length && item.objecttag[0]}}</div>
            <div class="Episode-playbutton" v-if="fromContinueSlider">
              <PlayButton :whereIamFrom="'continueWatch'" :content="item || null" :playerInstance="playerInstance"></PlayButton>
            </div>
            <!-- <div class="lock" v-if="!subscriberid"><img src="@/assets/icons/lock.svg" alt="lockicon"/></div> -->
            <div
              :class="[localDisplayLang === 'ara' ? 'category-tags-right' : 'category-tags']"
              v-if="item.objecttype === 'SERIES' && item.seasoncount >= 1"
            >
            <div class="category-tags-inner">
              <img src="@/assets/icons/ic_episodes.svg" alt />
              <span v-if="item.objecttype === 'SERIES'">{{ item.seasoncount }}</span>
            </div>
          </div>
            <LockBtn class="itsmeee" :content="item" :whereIamFrom="'hoverCard'" v-if="screen.itemType !== 'PROMOTIONS'"></LockBtn>
        </div>
      </div>
      <div class="swiper-button-next">
        <div class="next-btn-onhover"></div>
      </div>
      <div class="swiper-button-prev">
        <div class="prev-btn-onhover"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { eventBus } from "@/eventBus";
import Utility from "@/mixins/Utility.js";
import Redirection from "@/mixins/redirection.js";
import { observerInterSection } from "@/modules/observerInterSection";
import { subscriberid } from "../../../../store/getters";
import FirebaseActions from "@/mixins/FirebaseActions";

export default {
  props: ['title', 'id', 'screenName', 'screen', 'contentList', 'counterTextV', "showPlayBtn", "playerInstance", "screenId",  "fromContinueSlider", "showRemove", "fromWatchListSlider", "showMore"],
  data() {
    return {
      selected: false,
      selectedImage: false,
      localDisplayLang: 'en',
      onHoverSelectedItem: "",
      ismuted: true,
      Mute: require('@/assets/icons/mute.png'),
      Unmute: require('@/assets/icons/unmute.png'),
      placeholder_port: require('@/assets/placeholder-port.svg'),
      placeholder_lands: require('@/assets/placeholder-lands.svg'),
      placeholder_sqare: require('@/assets/placeholder-square.svg'),
      cronjob: "",
      videoInstance: "",
      landscapseImage: "",
      landscapeVideo: "",
      posterPushed: false,
      isMobile: false,
      isDisableOnHover: true,
      timerOn: '',
      volumeIconDimensions: { width: '36', height: '36' },
      displayType: '',
      mouseLeaveTimeout: null,
      contentData: null,
      cardDisplayType: {
          cardName: "Slider",
          height: "100%",
          width: "100%",
          playButton: { enablePlay: false, width: "40px", height: "40px" },
      }
    }
  },
  components: {
    WatchlistBtn: () => import( /* webpackChunkName: "watchlisbutton" */ "@/components/SvgImages/WatchList.vue"),
    LikeBtn: () => import( /* webpackChunkName: "likeBtn" */ "@/components/SvgImages/LikeBtn.vue"),
    PlayButton: () => import(/* webpackChunkName: "playButton" */ "@/components/buttons/play.vue"),
    VolumeIcon: () => import(/* webpackChunkName: "volumeIcon" */ "@/components/SvgImages/Volume.vue"),
    LockBtn: () => import(/* webpackChunkName: "lockBtn" */ "@/themeearth/components/dashboard/sliderCarousel/newLock.vue"),
    categoryCard: () => import(/* webpackChunkName: "genreDrop" */ "@/components/Templates/categoryCard.vue"),
  },
  mixins: [Utility, Redirection, FirebaseActions],
  methods: {

    screenClass(displayType, item) {
      if(displayType === 'LANDSCAPE') {
        return item.objecttype === "EPGPROGRAMME" ? 'landscape-img-with-title-view' : 'landscape-img-view'; 
      } else if(displayType === 'PORTRAIT') {
        return item.objecttype === "EPGPROGRAMME" ? 'portrait-img-with-title-view' : 'portrait-img-view';
      } else if(displayType === 'SQUARE') {
        return item.objecttype === "EPGPROGRAMME" ? 'square-img-with-title-view' :  'square-img-view';
      }
    }, 

    actLoadError (e) {
      e.target.src = this.placeholder_lands;
    },
    spliceText(text, maxLength) {
      if (text.length > maxLength) {
        return text.slice(0, maxLength) + '...'; // Splice text and add ellipsis
      } else {
        return text; // If text is within the limit, return it as is
      }
    },

    // seeAll(screen) {
    //   let screenData = JSON.stringify(screen);
    //   localStorage.setItem("screen-list-collection", screenData);

    //   let currentLanguage = this.getCurrentLanguageUrlBase();


    //   let titleDefault = this.spacialCharEncoding(screen.title.default);
    //   this.$router.push({
    //     name: "collections",
    //     params: { section: titleDefault.toLowerCase(), slug: this.screenId, lang: currentLanguage },
    //   });

    // },
    startMouseLeaveDetection() {
      // Add mousemove event listener to the document
      document.addEventListener('mousemove', this.handleMouseMove);
    },
    handleMouseMove(e) {
      const targetElement = document.querySelector(`#onhover-${this.id}`);
      if (targetElement) {
        const rect = targetElement.getBoundingClientRect();
        let isMouseInside = (
          e.clientX >= rect.left &&
          e.clientX <= rect.right &&
          e.clientY >= rect.top &&
          e.clientY <= rect.bottom
        );
        
        if (isMouseInside) {
           isMouseInside = true;
          if (this.mouseLeaveTimeout) {
            clearTimeout(this.mouseLeaveTimeout);
            this.mouseLeaveTimeout = null;
          }
        } else {
           isMouseInside = false;
          if (!this.mouseLeaveTimeout) {
            this.mouseLeaveTimeout = setTimeout(() => {
              if (!isMouseInside) {
                this.actRemovePlayer();
              }
            }, 300); // Delay before calling `actRemovePlayer`
          }
        }
      }
    },
    ChangeMute() {
      this.ismuted = !this.ismuted;
      const video = document.getElementById(`sliderVideoTrack-${this.id}`);
      video.muted = !video.muted;
    },
    getVideo(contentDetails) {
      return contentDetails.trailer && contentDetails.trailer[0] && contentDetails.trailer[0].filelist[0].filename ? contentDetails.trailer[0].filelist[0].filename : null;
    },
    getPoster(content, type) {
      if (content.posterurl) {
        return content.posterurl;
      }

      if (Array.isArray(content.poster)) {
        // Find poster with specified postertype and posterusage RAIL
        let poster = content.poster.find((element) => {
          return element.postertype === type && element.posterusage === "RAIL";
        });

        // If a valid poster is found, select quality in order: HD, SD, LOW, THUMBNAIL
        if (poster && Array.isArray(poster.filelist) && poster.filelist.length > 0) {
          let img = null;
          const qualityOrder = ["HD", "SD", "LOW", "THUMBNAIL"];
          for (let quality of qualityOrder) {
            const file = poster.filelist.find((f) => f.quality === quality);
            if (file) {
              img = file.filename;
              break;
            }
          }
          if (img) {
            return img;
          } else {
            if (type === "LANDSCAPE") {
              return this.placeholder_lands;
            } else if (type === "PORTRAIT") {
              return this.placeholder_port;
            } else if (type === "SQUARE") {
              return this.placeholder_sqare;
            }
          }
        }

        // Return placeholder if no poster is found
        if (type === "LANDSCAPE") {
          return this.placeholder_lands;
        } else if (type === "PORTRAIT") {
          return this.placeholder_port;
        } else if (type === "SQUARE") {
          return this.placeholder_sqare;
        }
      }

      if (content.inwatchlist) {
        return content.poster.landscape;
      } else if (content?.contentprovider === "CATCHUPTV" || content?.objecttype === "EPGPROGRAMME") {
        return content.thumbnail || this.placeholder_lands;
      } else if (content.thumbnail) {
        return content.thumbnail;
      } else {
        if (type === "LANDSCAPE") {
          return this.placeholder_lands;
        } else if (type === "PORTRAIT") {
          return this.placeholder_port;
        } else if (type === "SQUARE") {
          return this.placeholder_sqare;
        }
      }
    },
    actDetailsPage() {
      this.$router.push({
        name: 'detailPageEarth', params: {
          title: this.onHoverSelectedItem.defaulttitle.replaceAll(" ", "-"),
          contentId: this.onHoverSelectedItem.objecttype == "SEASON" ? this.onHoverSelectedItem.seriesid : this.onHoverSelectedItem.objectid
        }
      })
    },
    actDetailsPageMobile(item) {
      this.$router.push({
        name: 'detailPageEarth', params: {
          title: item.title.replaceAll(" ", "-"),
          contentId: item.objecttype == "SEASON" ? item.seriesid : item.objectid
        }
      });
    },
    calcTimeFormat(val) {
      if (!val) return;
      let totalTime = val;
      let hours = Math.floor(totalTime / 3600);
      let minutes = Math.floor((totalTime - hours * 3600) / 60);

      let showTime =
        (hours ? hours.toString().padStart(2, "0") + this.$t("hr") : "") +
        " " +
        (minutes ? minutes.toString().padStart(2, "0") + (minutes === 1 ? this.$t("min") : this.$t("mins")) : "");

      if (showTime == " ") {
        return val + this.$t("secs");
      } else {
        return showTime;
      }
    },
     formatSeasonCount(seasonCount) {
      if (!seasonCount) return;
      return seasonCount === 1 ? `1 ${this.$t("Season")}` : `${seasonCount} ${this.$t("Seasons")}`;
    },
    actMouseMove (e) {
      console.error("mouse move", e)
    },
    actRemovePlayer() {
      this.selected = false;

      setTimeout(() => {
        this.selected = false;
        this.onHoverSelectedItem && (this.onHoverSelectedItem.isActiveVideo = false);
      }, 100)

    },
    actRemovePlayerX() {
      clearTimeout(this.timerOn);
    },
    handingTiming(status, item, e) {
      clearTimeout(this.timerOn);
      this.timerOn = setTimeout(() => {
        this.actOnHoverPlayerActive(status, item, e)
      }, 1000);
    },
    actOnHoverPlayerActive(type, item, event) {
      if (this.isMobile || !this.isDisableOnHover) {
        return;
      }

      const targetItem = document.querySelector(`#onhover-${this.id}`);
      let sliderRow = document.querySelector(`.sliderRow${this.id}`);
      const targetElement = document.querySelector(`#onhover-${this.id}`);
      let rect = "";
      let mainElement = "";
      let xValue, yValue = 0;
      const maintainedValue = document?.querySelector(`.sliderRow${this.id}`)?.getBoundingClientRect().x;

      this.selected = type;
      this.onHoverSelectedItem = item;
      this.landscapseImage = this.getPoster(item, 'LANDSCAPE')
      this.landscapeVideo = "";
      this.landscapeVideo = this.getVideo(item)
      this.onHoverSelectedItem && (this.onHoverSelectedItem.isActiveVideo = false);
      this.autoPosterVideoSwitch();
    
      if (targetElement) {
         rect = targetElement.getBoundingClientRect();
      }

      mainElement = event?.target?.getBoundingClientRect();

      xValue = (mainElement?.x - maintainedValue) + ((mainElement?.width / 2) - (rect?.width / 2));
      yValue =  0;

      xValue = xValue < 0 ? 0 : xValue;
   
      if ( sliderRow && sliderRow.scrollWidth < mainElement.right ) {
        xValue = sliderRow.scrollWidth - rect.width;
      }
      if (targetElement) {
       targetItem.style.transform = `translate(${xValue}px, ${yValue}px)`;
      }
      [...document?.getElementsByClassName('image__item_video')]?.forEach((item) => {
        item.muted = true
      })
      eventBus.$emit('event-isMuted')
    },
    autoPosterVideoSwitch() {
      this.onHoverSelectedItem = JSON.parse(JSON.stringify(this.onHoverSelectedItem));

      setTimeout(() => {
        this.onHoverSelectedItem && (this.onHoverSelectedItem.isActiveVideo = true);
      }, 1000)
    },
    cbFireScroll() {
      this.selected = false;
    },
    removeDataFromFire(data) {
      this.selected = !this.selected;
      // this.removeFromContinueWatch(data);
      // this.contentData = [...this.contentData?.filter((item, i) => {
      //   return data.objectid!== item.objectid;
      // })];
      eventBus.$emit("show-warning", data);
      eventBus.$on("remove-watchlist-content", (confirmedContent) => {
      if (confirmedContent.objectid === data.objectid) {
        this.$emit("remove", data);
      }
    })
    },
  },
  mounted() {
    // console.log('screen_info', this.screen);
    this.contentData = [...this.contentList];
    console.log('screen_info', this.contentData);
    this.cardDisplayType.type = this.screen.displayType;
    // this.cardDisplayTypeplayButton = { enablePlay: true, width: "40px", height: "40px" },
    observerInterSection();
    this.startMouseLeaveDetection();
    // Add mousemove listener to the entire document
    this.isMobile = window.innerWidth <= 900 ? true : false,

      this.displayType = this.screen?.displayType == 'LANDSCAPE' ? 'LANDSCAPE' : 'PORTRAIT';

    this.localDisplayLang = localStorage.getItem("setDisplayLanguageCode");


    let breakpoints = {
      300: {
        slidesPerView: this.displayType == 'PORTRAIT' ? 3 : 2,  // Adjust the number of posters for mobile devices
        spaceBetween: 5  // Adjust the space between posters for mobile devices
      },
      420: {
        slidesPerView: this.displayType == 'PORTRAIT' ? 2.5 : 1.7,  // Adjust the number of posters for mobile devices
        spaceBetween: 5  // Adjust the space between posters for mobile devices
      },
      500: {
        slidesPerView: this.displayType == 'PORTRAIT' ? 3.5 : 2,  // Adjust the number of posters for mobile devices
        spaceBetween: 7  // Adjust the space between posters for mobile devices
      },
      630: {
        slidesPerView: this.displayType == 'PORTRAIT' ? 4 : 2.8,  // Adjust the number of posters for mobile devices
        spaceBetween: 10  // Adjust the space between posters for mobile devices
      },
      768: {
        slidesPerView: this.displayType == 'PORTRAIT' ? 4 : 3,  // Adjust the number of posters for mobile devices
        spaceBetween: 12  // Adjust the space between posters for mobile devices
      },

      992: {
        slidesPerView: this.displayType == 'PORTRAIT' ? 5.2 : 4.5,
        spaceBetween: 20
      },

      1024: {
        slidesPerView: this.displayType == 'PORTRAIT' ? 6.3 : 4.7,
        spaceBetween: 20
      },

      1500: {
        slidesPerView: this.displayType == 'PORTRAIT' ? 7.3 : 6.7,
        spaceBetween: 10
      },
      1800: {
        slidesPerView: this.displayType == 'PORTRAIT' ? 8.3 : 7.1,
        spaceBetween: 10
      }
    }


    let swiper = new window.Swiper(`.sliderRow${this.id}`, {
      slidesPerView: 2,  // Set the number of slides directly for testing
      cssMode: true,
      lazy: true,
      spaceBetween: 10,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      on: {
        init: function () {
          this.isDisableOnHover = true;
        },
      },
      breakpoints,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });

  },
  computed: {
  },
  watch: {
    contentList(newVal, oldVal) {
      this.contentData = [...newVal];
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/sass/_variables.scss";
@import "@/sass/_components.scss";

:root {
  --blue: #1e90ff;
  --white: $clr-saina-light-dark-txtf;
  --VERTICAL-CARD-HOVER-SCALE-X: 0.8;
  --VERTICAL-CARD-HOVER-SCALE-Y: 0.8;
}
    .category-tags {
          position: absolute;
          right: 0;
           top: 0;
          padding: 0.1rem;
          background: rgba(0, 0, 0, 0.5);
          border-top-left-radius: 5px;
          border-bottom-left-radius: 5px;
          .category-tags-inner {
            display: flex;
            gap: 0.2rem;
            align-items: center;
            justify-content: center;
            padding: 0.2rem;
            img {
              height: 10px;
              width: 10px;
            }
            span {
              font-size: 0.7rem;
              font-weight: bold;
              font-family: $font-regular;
            }
          }
        }
        .category-tags-right {
          position: absolute;
          top: 5%;
          left: 0%;
          padding: 2px 10px;
          background: rgba(0, 0, 0, 0.5);
          border-top-right-radius: 5px;
          border-bottom-right-radius: 5px;
          img {
            height: 10px;
            width: 10px;
          }
          span {
            font-size: 0.7rem;
            font-weight: bold;
            font-family: $font-regular;
          }
        }
        .live-button {
        position: absolute;
        padding: .2rem;
        background: #EF6537;
        top: 5px;
        left: 5px;
        font-size: .8rem;
        border-radius: .25rem;
        display: flex;
        align-items: center;
        justify-content: center;  
        font-weight: bold;
        border-radius: 4px;
        cursor: default; 
        animation: pulse 2s infinite ease-in-out;
        outline: none;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        }

        @keyframes pulse {
          0% {
            transform: scale(1);
            opacity: 1;
          }
          50% {
            transform: scale(1.05);
            opacity: 0.9;
          }
          100% {
            transform: scale(1);
            opacity: 1;
          }
        }

.swiper {
  width: 100%;
  height: 100%;
}

.landscape-img-view {
  aspect-ratio: 16 / 9;
  img {
    border: 1px solid #282828;
    aspect-ratio: 16 / 9;
  }
}
.landscape-img-with-title-view {
  aspect-ratio: 16 / 11;
  img {
    border: 1px solid #282828;
    aspect-ratio: 16 / 9;
  }
}

.portrait-img-view {
  aspect-ratio: 2 / 3;
  img {
    border: 1px solid #282828;
    aspect-ratio: 2 / 3;
  }
}
.portrait-img-with-title-view {
  aspect-ratio: 2 / 3.5;
  img {
    border: 1px solid #282828;
    aspect-ratio: 2 / 3;
  }
}

.square-img-view {
  aspect-ratio: 1 / 1;
  img {
    border: 0.14rem solid #212020;
  }
}
.square-img-with-title-view {
  aspect-ratio: 1 / 1.25;
  img {
    border: 1px solid #282828;
    aspect-ratio: 1 / 1;
  }
}

.swiper-slide {
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  text-align: center;
  font-size: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  z-index: 9;
  cursor: pointer;

}

.swiper-slide {
  .poster-img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 8px;
    background: #282828;
    // transform: translateZ(0);
    // will-change: transform;
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
    /* Tells the browser to use high-quality hardware optimization paths */
    image-rendering: -webkit-optimize-contrast;
  }
  .poster-img.loaded {
  opacity: 1;
}
}

.swiper-slide img[src] {
  opacity: 1;
}

.swiper-slide {
  flex-direction: column;
}
.swiper-slide .title-show {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: small;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  color: #e1e6f0;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  overflow: hidden;
  overflow-wrap: break-word;
  font-size: 1rem;
  font-weight: 500;
  line-height: 20px;
  text-align: start;
  padding: 0.4rem;
}

.slider-category-title {
  font-size: 1.3rem;
  margin: 0.8rem 0.1rem;
  color: $clr-saina-light-dark-txt;
}

.swiper-button-next-overlay {
  height: 15rem;
  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.85) 30%, rgba(0, 0, 0, 0.0) 90%);
  position: absolute;
  width: 3rem;
  top: 0px;
  display: block;
  z-index: 9999;
  // pointer-events: none;
  margin-top: auto !important;
}

::after {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  left: 50%;
}

.swiper-button-next-overlay[aria-disabled="true"] .swiper-button-prev-overlay[aria-disabled="true"] {
  background-image: linear-gradient(to right, rgba(0, 0, 0, 0) 30%, rgba(0, 0, 0, 0.85) 90%);
}

.swiper-button-prev-overlay {
  height: 16rem;
  position: absolute;
  width: 3rem;
  top: 0px;
  right: 0;
  display: block;
  z-index: 9999;
  margin-top: auto !important;
}


.onhover-poster.visible {
  opacity: 1;
  visibility: visible;
}

.onhover-poster.hidden {
  opacity: 0;
  visibility: hidden;
}

.onhover-poster {
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease-in, visibility 0.3s ease-in, width 0.3s ease-in;
  position: absolute;
  z-index: 999;
  left: 0rem;
  cursor: pointer;
  .hover-card {
    z-index: 999;

    width: 20rem;
    height: 25rem;
    background: #101113;
    transform-origin: center center;
    position: relative;
    border-radius: 0.5rem;
    box-shadow: 0px 0px 5px 3px #00000073;

    figure {
      width: 100%;
      height: 50%;

      .image__item_video {
        width: 100%;
        height: 100%;
        border-radius: 0.5rem 0.5rem 0 0;
        height: 12rem;
        object-fit: cover;

      }

      .image__item {
        width: 100%;
        height: 100%;
        border-radius: 0.5rem 0.5rem 0;
      }

      .related-meta-data {
        padding: 0.75rem;
        display: flex;
        flex-direction: column;
        gap: 0.5rem;

        .related-action-btns {
          display: flex;
          gap: 1rem;
        }

        .related-meta-data-details {
          display: flex;
          flex-direction: column;
          gap: 0.5rem;

          .fig-title {
            font-weight: 500;
            font-size: 1rem;
          }

          .fig-details {
            display: flex;
            gap: 0.8rem;
            flex-direction: column;

            .main-info {
              display: flex;
              gap: 1rem;
              font-size: 0.85rem;
              align-items: center;

              .publish-year,
              .duration {
                color: #aaaaaa;
              }

              .pgrating {
                border: #3b3a3a 0.8px solid;
                padding: 0.1rem 0.4rem;
                border-radius: 0.2rem;
                color: #ffffff;
              }
            }

            .main-genre {
              display: flex;
              gap: 1rem;
              font-size: 0.85rem;
            }

            .main-genre .sub-genre2 p::before,
            .main-genre .sub-genre3 p::before {
              content: "• ";
              position: relative;
              right: 0.4rem;
            }
          }

          .fig-description {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: pre-wrap;
            color: rgba(170, 170, 170, 1);
            font-weight: 400;
            font-size: 0.8rem;
            height: 3rem;
          }
        }
      }
    }
  }

}

.mute-unmute-btn-slider {
  position: absolute;
  right: 1rem;
  bottom: 2rem;
  z-index: 999999;
}

.Episode-playbutton {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.home-class-main {
 // margin-left: 1rem;
  position: relative;
}


.next-btn-onhover {
  background: #000;
  width: 4rem;
  height: 24rem;
  position: absolute;
  opacity: 0.3;
  border-radius: 10px;

}

.prev-btn-onhover {
  background: #000;
  width: 4rem;
  height: 24rem;
  position: absolute;
  opacity: 0.3;
  border-radius: 10px;
}

.slider-header {
  margin-top: 0.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 5px 0px 0.7rem;

  .seeall {
    cursor: pointer;
    font-size: 1.2rem;
    font-weight: 600;
    letter-spacing: 0.75px;
    padding: 0 5px;
    transition: 0.1s;
    align-self: center;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 0rem;
    margin-bottom: 3rem;

    &:hover {
      transform: scale(1.05);
      color: $clr-light-gd3;
    }
  }

  .seeall-arrow {
    position: relative;
    top: 0.22rem;
    width: 1rem;
    height: 1.6rem;
  }

  .slider-head {
    display: flex;
    justify-content: flex-end;
    align-items: center;

    .slider-head-btns {
      margin-top: 3px;

      .slider-controls {
        button {
          border: none;
          background: transparent;


          cursor: pointer;

          img {
            height: 1.6rem;
            width: auto;
          }

          &:disabled {
            opacity: 0.3;
            display: flex;
          }

          &:focus {
            outline: none;
          }
        }

        &:focus {
          outline: none;
        }
      }
    }
  }
}

.swiper-button-prev, .swiper-rtl .swiper-button-next {
  transform: scale(0.7);
}
.swiper-button-next, .swiper-rtl .swiper-button-prev {
  transform: scale(0.7);

}

.slider-content {
  .content-slider {
    &:focus {
      outline: none;
    }
  }
}


.badge {
  position:absolute;
  padding:0.2rem;
  background:$primary-btn-color;
  top: 5px; 
  left: 5px;
  font-size: 0.8rem;
  border-radius:0.25rem
 }

@media screen and (max-width: 786px) {
  .swiper-button-next, .swiper-button-prev, .more {
    display: none;
  }
  .slider-category-title, .seeall {
    font-size: 0.8rem !important;
    margin: 0.5rem;
    text-transform: uppercase;
    font-weight: 600;
  }

}

@media screen and (min-width: 786px) and (max-width: 1023px) {
 .slider-category-title, .seeall {
    font-size: 0.9rem !important;
    margin: 0.5rem;
    text-transform: uppercase;
    font-weight: 600;
 }
 .badge {
  position: absolute;
  padding: 0.2rem;
  background: $primary-btn-color;
  top: 5px; 
  left: 5px;
  font-size: 0.5rem;
  border-radius: 0.25rem
 }
 .next-btn-onhover, .prev-btn-onhover {
    width: 2.5rem;
    height: 5rem;
  }
  .seeall-arrow {
    font-size: 1rem;
    font-weight: 600;
  }
}

.epg-info {
  font-size: 0.65rem;
}
.remove-btn {
  position: absolute;
  top: 1%;
  right: 1%;
  width: 10%;
  aspect-ratio: 1 / 1;
  display: flex;
  align-items: center;
  justify-content: center;
  // background-image: url("~@/assets/icons/close_icon.png");
  // background-size: contain;
  .img {
    width: 100%;
    height: 100%;
  }
}

.poster-img { opacity: 0}
.poster-img.loaded { opacity: 1 }

</style>